/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-16 19:33:10
 * @FilePath: /vise/packages/app-share/src/utils/request.ts
 */

import cookie from 'cookie';
import { IS_SSR } from './env';

type ReqHeader = {
  personId: string,
  authInfo: {
    refreshToken: string,
    accessToken: string,
    sessionKey: string,
    authType: number,
    thrAppId: string,
    uid: string,
  },
  channelId: number, // 端外H5永远传4
};

export function getReqHeader(): null | ReqHeader {
  if (IS_SSR) return null;
  const cookieInfo = cookie.parse(document.cookie as string || '');
  const authType = Number(cookieInfo.iAuthType);
  const sessionKey =  authType === 3 ? cookieInfo.accessToken : cookieInfo.sSessionKey;
  return {
    personId: cookieInfo.person_id,
    authInfo: {
      refreshToken: cookieInfo.refreshToken,
      accessToken: cookieInfo.accessToken || '',
      sessionKey: sessionKey || '',
      authType,
      thrAppId: cookieInfo.sThrAppid,
      uid: cookieInfo.openid,
    },
    channelId: 4,
  };
}
